import { Component, OnInit, Inject, Input } from '@angular/core';
import { EnvironmentProvider } from '../../../core/browser-providers';
import { Environment } from '../../../../environments/enviroment.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../../../core/backend.service';
import { MatPaginatorIntl } from '@angular/material';
import { UpdateEventService } from '../../../shared-services/update-event.service';
import { MediaService } from '../../../shared-services/media.service';
import { SecurityService } from '../../../security/security.service';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';
import { Operacion } from '../operacion.model';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

interface Filters {
  cliente: number;
  page: number;
  size: number;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-listado-cliente',
  templateUrl: './listado-cliente.component.html',
  styleUrls: ['./listado-cliente.component.scss']
})
export class ListadoClienteComponent implements OnInit {

  @Input() id: number;

  private filters: Filters = {
    cliente: this.id,
    page: 0,
    size: 10,
  };

  public showFilters = true;
  isMobile: boolean;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  operacionesList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(Operacion, Operacion.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
      }
    })();
  }).share() as Observer<Filters> & Observable<Operacion[]>;

  constructor(@Inject(EnvironmentProvider) env: Environment,
  private route: ActivatedRoute,
  private backendService: BackendService,
  private paginatorsLabels: MatPaginatorIntl,
  public router: Router,
  protected updateEventService: UpdateEventService,
  private mediaService: MediaService,
  public securityService: SecurityService) { }

  ngOnInit() {

    this.filtersLoaded = true;

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.operacionesList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

  }

  refreshRoleList() {
    this.getDefaultFilters();
    this.operacionesList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      cliente:  this.id,
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshRoleList();
  }

  onSearch(searchText) {
    this.refreshRoleList();
  }

  clearSearch() {
    this.refreshRoleList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onFiltersChanged(event) {
    this.refreshRoleList();
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/operaciones/listado-cliente/listado-cliente.component.ts